import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { BrokerChallengeSubscribePage } from '#/modules/broker-challenge/back-office/broker-challenge-subscribe-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/challenges/$challengeId/subscribe')({
  beforeLoad: (options) => requirePermissions(options, ['challenge.subscribe']),
  component: Component,
})

function Component(): ReactElement {
  const { challengeId } = Route.useParams()
  return <BrokerChallengeSubscribePage challengeId={challengeId} />
}
